<div class="web-post web-post-{{post.type}}" [attr.id]="post.id">

  <div class="post-title">
    {{ (post.date ? (post.date+' – ') : '') + (post.title | multilang) }}
    <a *ngIf="post.id" class="post-permalink" [href]="permalink" (click)="copyPermalink($event)"
       title="{{ (copied ? 'content.link-copied' : 'content.permalink') | translate }}"
       [attr.aria-label]="'content.permalink' | translate">
      <i class="pi" [ngClass]="copied ? 'pi-check' : 'pi-link'"></i>
    </a>
  </div>

  <div *ngIf="post.type=='message'">
    <message-card [setData]="$any(post.content)"></message-card>
  </div>
  <div *ngIf="post.type=='photo'">
    <photo-card [setData]="$any(post.content)"></photo-card>
  </div>
  <div *ngIf="post.type=='gallery'">
    <fs-gallery-card [setData]="$any(post.content)"></fs-gallery-card>
  </div>
  <div *ngIf="post.type=='video'">
    <video-card [setData]="$any(post.content)"></video-card>
  </div>

</div>
